import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { AlreadyTranslated, T } from '../../../../../../../Translations';
import { ProductLicenseResource } from '../../../../../Types';

interface Props {
  productLicense: ProductLicenseResource;
}

function Congrats({ productLicense }: Props) {
  return productLicense.payload.licenseTypePublicName
    .map((licenseTypePublicName) => {
      const licenseTitle = <AlreadyTranslated content={licenseTypePublicName} />;
      return (
        <div className="p-3 mt-4 text-sm bg-green-500 bg-opacity-20 rounded border-1 border-gray-300">
          <T
            kind="Potential unlocked! Nice job, this collection includes all types of programs available with your <licenseTitle/> license."
            licenseTitle={licenseTitle}
          />
        </div>
      );
    })
    .getOrElse(emptyFragment);
}

export default observer(Congrats);
